import React from "react"
import dict from "../utils/dict.json"

export default React.createContext(dict)
